import { render } from "./PledgeManagerInfoSetupSteps.vue?vue&type=template&id=241d82ac"
import script from "./PledgeManagerInfoSetupSteps.vue?vue&type=script&lang=js"
export * from "./PledgeManagerInfoSetupSteps.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__